// extracted by mini-css-extract-plugin
export default {"title":"PirmaDalaDators_title__I31Bj","content":"PirmaDalaDators_content__UB5O+"};